const PAYMENT_TYPES = {

  debitCard: "debit-card",

  bankTransfer: "bank-transfer"

};

export default PAYMENT_TYPES;
